export const buildLoginRedirectHref = (loginPath: string): string => {
  const searchParams = new URLSearchParams({
    returnTo: window.location.pathname + window.location.search,
  }).toString();

  return `${loginPath}?${searchParams}`;
};
